import React from 'react';
import ReactDOM from 'react-dom';
import charWatchTrack from '../shared/CharWatchTrack';

class LcTrack extends React.Component {
    render() {
        return (
            <div></div>
        );
    }
}

export default charWatchTrack(LcTrack, 'lc', 'track');


// WEBPACK FOOTER //
// ./src/components/sections/lc/LcTrack.js